<nav class="navbar topHeader navbar-dark navbar-expand-sm fixed-top">
    <a class="navbar-brand" routerLink="/dashboard"><img alt="mahatrack" height="35" src="assets/img/maha_track_logo2.png"> mahakhanij Track
    </a>
    <button class="navbar-toggler" type="button" style="color: rgba(255,255,255,.5); border-color: rgba(255,255,255,.1);" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarTogglerDemo01" >
        <ul class="navbar-nav ml-auto">
            <li class="nav-item"   *ngIf="!mahaminingDevice">
                <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"   *ngIf="mahaminingDevice">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dashboard
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" routerLink="dashboard" routerLinkActive="active">Sand Dashboard</a>
                    <a class="dropdown-item" routerLink="tracking-dashboard" routerLinkActive="active">Tracking Dashboard</a>
                </div>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  *ngIf="mahaminingDevice">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Map
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" routerLink="liveLocation" routerLinkActive="active">Live Location</a>
                    <a class="dropdown-item" routerLink="tracking" routerLinkActive="active">Tracking</a>
                    <!-- <a class="dropdown-item" routerLink="vehicleCurrentLocation" routerLinkActive="active">Vehicle Current Location</a> -->
                </div>
            </li>

           <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="mahaminingDevice">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Master
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                    <a class="dropdown-item" routerLink="poi" routerLinkActive="active">POI</a>
                     <!-- <a class="dropdown-item" routerLink="breakDown" routerLinkActive="active">Break
                        Down</a> -->
                    <a class="dropdown-item" routerLink="payment" routerLinkActive="active">Payment</a>
                    <a class="dropdown-item" routerLink="paymentHistory" routerLinkActive="active">Payment History</a>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/vehicleList" routerLinkActive="active">Vehicle List</a>
            </li>
            <ng-container>
                <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Booking
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
    
                        <a class="dropdown-item" routerLink="my-booking" routerLinkActive="active">My Booking</a>
                        <a class="dropdown-item" routerLink="booking-history" routerLinkActive="active">Slot Booking  History</a>
                    </div>
                </li>
            <li class="nav-item"  >
                <a class="nav-link" routerLink="complaint" routerLinkActive="active">Complaint</a>
            </li>
        </ng-container>
            <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  [class.d-none]="!mahaminingDevice">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Reports</a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li class="dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a class="dropdown-toggle dropdown-item active1" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">General</a>
                        <ul class="dropdown-menu subsubmenu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" routerLink="summary" routerLinkActive="active">Summary</a>
                            <a class="dropdown-item" routerLink="speedRange" routerLinkActive="active">Speed
                                Range</a>
                            <a class="dropdown-item" routerLink="trip" routerLinkActive="active">Trip</a>
                            <a class="dropdown-item" routerLink="address" routerLinkActive="active">Address</a>
                            <a class="dropdown-item" routerLink="overSpeed" routerLinkActive="active">Overspeed</a>
                        </ul>
                    </li>
                    <li class="dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a class="dropdown-toggle dropdown-item active1" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mining</a>
                        <ul class="dropdown-menu subsubmenu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" routerLink="eTP" routerLinkActive="active">eTP</a>
                            <a class="dropdown-item" routerLink="materialOrder" routerLinkActive="active">Material
                                Order</a>
                        </ul>
                    </li>
                </ul>
            </li>
            <li class="nav-item dropdown">

                <a class="nav-link dropdown-toggle web-view  hide-after" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-custom dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <div class="user-dropdown-header">
                        <div class="user-avatar-badge">
                            {{ (getUserName || 'VO').slice(0,2).toUpperCase() }}
                        </div>
                        <div class="user-info-text pl-2">
                            <h6 class="user-name-title text-truncate" [title]="getUserName">{{getUserName}}</h6>
                            <span class="user-mobile-sub text-truncate d-block">
                                <i class="fas fa-phone-alt mr-1"></i>{{getMobileNo}}
                            </span>
                        </div>
                    </div>
                    <div class="user-dropdown-body">
                        <a class="dropdown-item user-dropdown-link" routerLink="profile" routerLinkActive="active">
                            <span class="icon-circle bg-blue-subtle">
                                <i class="fas fa-user"></i>
                            </span>
                            <span>Profile</span>
                        </a>
                        <a class="dropdown-item user-dropdown-link" routerLink="changePassword" routerLinkActive="active">
                            <span class="icon-circle bg-amber-subtle">
                                <i class="fas fa-key"></i>
                            </span>
                            <span>Change Password</span>
                        </a>
                        <div class="dropdown-divider-custom"></div>
                        <a class="dropdown-item user-dropdown-link logout-link" data-toggle="modal" data-target="#exampleModal1">
                            <span class="icon-circle bg-red-subtle">
                                <i class="fas fa-power-off"></i>
                            </span>
                            <span class="text-danger font-weight-600">Logout</span>
                        </a>
                    </div>
                </div>
            </li>

        </ul>
    </div>
</nav>

<!-- Modal -->
<div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLabel1">Logout </h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body text-center">
                <i class="fas fa-question-circle fa-4x text-danger"></i>
                <h6 class="mt-4"> Are you sure you want to logout?</h6>
            </div>
            <div class="text-center mb-3">
                <button type="button" class="btn btn-outline-secondary btn-sm mr-1" style="width: 100px;" data-dismiss="modal">No</button>
                <button type="button" class="btn btn-outline-main btn-sm  ml-1" style="width: 100px;" (click)="logout()" data-dismiss="modal">Yes</button>
            </div>
        </div>
    </div>
</div>

<!-- new model for session  -->
<!-- Button trigger modal -->
